import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from "@material-ui/core";

export default function FlowBuilderTaskModal({ open, data, onSave, onUpdate, close }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState("medium");
  const [dueDays, setDueDays] = useState(1);
  useEffect(() => {
    if (!open) return;
    const values = open === "edit" ? data?.data || {} : {};
    setTitle(values.title || "");
    setDescription(values.description || "");
    setPriority(values.priority || "medium");
    setDueDays(values.dueDays ?? 1);
  }, [open, data]);
  const save = event => {
    event.preventDefault();
    const days = Number(dueDays);
    if (!title.trim() || !Number.isInteger(days) || days < 0 || days > 365) return;
    const values = { title: title.trim(), description: description.trim(), priority, dueDays: days };
    if (open === "edit") onUpdate({ ...data, data: values });
    else onSave(values);
    close(null);
  };
  return <Dialog open={Boolean(open)} onClose={() => close(null)} fullWidth maxWidth="sm">
    <form onSubmit={save}>
      <DialogTitle>{open === "edit" ? "Editar tarefa" : "Criar tarefa no fluxo"}</DialogTitle>
      <DialogContent style={{ display: "grid", gap: 14 }}>
        <TextField label="Título da tarefa" value={title} onChange={event => setTitle(event.target.value)}
          inputProps={{ maxLength: 160 }} required autoFocus fullWidth />
        <TextField label="Descrição (opcional)" value={description} onChange={event => setDescription(event.target.value)}
          inputProps={{ maxLength: 2000 }} multiline rows={3} fullWidth />
        <TextField select label="Prioridade" value={priority} onChange={event => setPriority(event.target.value)} fullWidth>
          <MenuItem value="low">Baixa</MenuItem><MenuItem value="medium">Média</MenuItem><MenuItem value="high">Alta</MenuItem>
        </TextField>
        <TextField type="number" label="Prazo em dias (0 = hoje)" value={dueDays}
          onChange={event => setDueDays(event.target.value)} inputProps={{ min: 0, max: 365, step: 1 }} fullWidth />
        <small>A tarefa será vinculada ao lead e atribuída ao responsável pelo atendimento, quando houver.</small>
      </DialogContent>
      <DialogActions><Button onClick={() => close(null)}>Cancelar</Button><Button type="submit" color="primary" variant="contained">Salvar</Button></DialogActions>
    </form>
  </Dialog>;
}
